import { Error, Text } from "./ErrorInvalid.styled";

export default function ErrorInvalid() {
    return (
        <Error>
            <Text>
                <strong>
                    De ingevulde code wordt niet herkend, controleer of je de
                    juiste code hebt ingevuld.
                </strong>
            </Text>
            <Text>
                Blijft dit probleem zich voordoen? <br /> - Controleer of de
                ontvangen kaart wel een Lees! Cadeaukaart is <br />- Heb je alle
                19 cijfers ingevuld?
            </Text>
            <Text>
                Lukt het nog steeds niet? Neem dan contact op via:
                info@lees-cadeaukaart.nl.
            </Text>
        </Error>
    );
}
